/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
const t="https://.*";function n(t){return!!t&&/^https:\/\/.*/i.test(t)}function e(t){return!!t&&/data:([-\w]+\/[-+\w.]+)?(;?\w+=[-\w]+)*(;base64)?,.*/gu.test(t)}export{t as ThumbnailInputPattern,e as isDataURI,n as isSecureUrl};
